import { Alert, Backdrop, Box, CircularProgress, Fade, Grid, IconButton, Modal, Paper, Tooltip, Typography } from "@mui/material"
import { FileDropperV2 } from "../../../../../components/FileDropper/fileDropper";
import { useState } from "react";
import { CloudUpload, Delete, NoteAdd, UploadFile } from "@mui/icons-material";
import { GetResourcesRevisiones } from "../../../../../hooks/partesRevisiones";
import { RecursosEnum } from "../../../../../@enums/tipo_images.enum";
import { CrearRecurso } from "../../../../../hooks/createRecursos";
import { useSelector } from "react-redux";
import { BorrarRecurso } from "../../../../../hooks/delRecurso";
import swal from "sweetalert2";
import { useLoading } from "../../../../../components/Loading/useLoading";
import { ImageViewer } from "../../../../../components/FileDropper/imageViewer";

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 800,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  display: 'flex',
  justifyContent: 'center',
  maxHeight: 500,
  overflowY: 'auto'
};

export const ModalArchivosRevisiones = ({ open, handleClose, revision }) => {

  const apiResources = useSelector((state) => state.app.apiResources);

  const { isLoading, isError, data, refetch } = GetResourcesRevisiones(revision?.pare_id);
  const { setAppLoading } = useLoading();
  const { crearRecursoMutation } = CrearRecurso();
  const { borrarRecursoMutation } = BorrarRecurso();
  const [isUpload, setIsUpload] = useState(false);
  const [files, setFiles] = useState([]);
  const [openImage, setOpenImage] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  let extraData = {
    pare_id: revision?.pare_id,
    recu_tipo: RecursosEnum.REVISION,
  }

  const finallyUpload = (files) => {
    console.log('Archivos seleccionados:', files);
    setFiles(files);
  };

  const openUpload = () => {
    setIsUpload(true)
  }

  const closeModal = () => {
    setIsUpload(false);
    handleClose();
  }

  const uploadData = () => {
    setAppLoading(true);
    crearRecursoMutation({ extraData, files }, {
      onSuccess: (data) => {
        swal
          .fire({
            position: "top-end",
            icon: data?.success ? "success" : "error",
            title: data?.mensaje,
            showConfirmButton: false,
            timer: 1500,
          })
      },
      onError: (error) => {
        swal
          .fire({
            position: "top-end",
            icon: "error",
            title: data?.mensaje,
            showConfirmButton: false,
            timer: 1500,
          })
      },
      onSettled: () => {
        setIsUpload(false);
        setFiles([]);
        setTimeout(() => {
          refetch();
          setAppLoading(false);
        }, 5000);
      }
    })
  }

  const deleteFile = (recu_id) => {
    setAppLoading(true);
    borrarRecursoMutation(recu_id, {
      onSuccess: (data) => {
        if (data.success) {
          swal.fire({
            title: "Eliminado",
            text: "El archivo se elimino correctamente",
            icon: "success"
          })
        } else {
          swal.fire({
            position: "center",
            icon: "error",
            title: "Hubo un problema al eliminar el archivo, intentalo de nuevo",
            showConfirmButton: false,
            timer: 1500
          })
        }
      },
      onError: (error) => {
        swal.fire({
          position: "center",
          icon: "error",
          title: "Hubo un problema al eliminar el archivo, intentalo de nuevo",
          showConfirmButton: false,
          timer: 1500
        })
      },
      onSettled: () => {
        refetch();
        setAppLoading(false);
      }
    })
  }

  const handleImageClick = (imageUrl) => {
    let resUrl = `${apiResources}/${imageUrl}`
    setSelectedImage(resUrl);
    setOpenImage(true);
  }

  const handleCloseImage = () => {
    setOpenImage(false);
    setSelectedImage(null);
  }

  const handleOpenPDF = (pdfUrl) => {
    // let resUrl = `${apiResources}/${pdfUrl}`
    let resUrl = `https://docs.google.com/gview?url=${encodeURIComponent(`${apiResources}/${pdfUrl}`)}`;
    window.open(resUrl, '_blank');
  };

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      onClose={closeModal}
      closeAfterTransition
      slots={{ backdrop: Backdrop }}
      slotProps={{
        backdrop: {
          timeout: 500,
        },
      }}
      sx={{ zIndex: 2 }}
    >
      <Fade in={open}>
        <Box sx={style}>
          <Grid container spacing={0}>
            <Grid item xs={12} sx={{ p: 0, mb: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }} >
              <Typography>
                {`Revisión ${revision?.pare_nombre}`}
              </Typography>
              {
                isUpload &&
                <Tooltip title="Subir archivos" placement="top">
                  <IconButton aria-label="delete" onClick={uploadData}>
                    <CloudUpload />
                  </IconButton>
                </Tooltip>
              }
              {
                !isUpload &&
                <Tooltip title="Agregar archivos" placement="top">
                  <IconButton aria-label="delete" onClick={openUpload}>
                    <NoteAdd />
                  </IconButton>
                </Tooltip>
              }
            </Grid>
            {!isUpload && data?.length > 0 &&
              <>
                {
                  data.map((res) => (
                    <Grid item xs={12} sm={6} md={4} key={`res_rev_${res?.recu_id}`} sx={{ p: 2 }}>
                      <Paper sx={{ p: 2, display: 'flex', alignItems: 'center' }}>
                        {res.recu_mime.startsWith('image') ? (
                          <Box
                            component="img"
                            src={`${apiResources}/${res?.recu_ruta}`}
                            alt={res?.recu_nombre}
                            sx={{
                              width: 60,
                              height: 60,
                              objectFit: 'cover',
                              mr: 2,
                              borderRadius: 1,
                            }}
                            onClick={() => handleImageClick(res?.recu_ruta)}
                          />
                        ) : (
                          <Box
                            sx={{
                              minWidth: 60,
                              height: 60,
                              mr: 2,
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              bgcolor: 'grey.200',
                              borderRadius: 1,
                            }}
                            onClick={() => handleOpenPDF(res?.recu_ruta)}
                          >
                            <UploadFile />
                          </Box>
                        )}
                        <Typography noWrap sx={{ flexGrow: 1 }}>{res?.recu_nombre}</Typography>
                        <IconButton color="error" onClick={() => deleteFile(res?.recu_id)}>
                          <Delete />
                        </IconButton>
                      </Paper>
                    </Grid>
                  ))
                }
              </>
            }
            {
              isUpload &&
              <Grid item xs={12} sx={{ p: 0, mb: 1, pr: 1 }}>
                <FileDropperV2 key='fd_v2' onFilesChange={finallyUpload} extraData={extraData} />
              </Grid>
            }
            {
              isLoading &&
              <Grid item xs={12} sx={{ p: 0, mt: 3, display: 'flex', alignItems: 'center', justifyContent: 'center' }} >
                <CircularProgress />
              </Grid>
            }
            {
              data?.length === 0 &&
              <Grid item xs={12} sx={{ p: 0, mt: 3, display: 'flex', alignItems: 'center' }} >
                <Alert severity="warning" sx={{ width: '100%' }}>No existen archivos en esta revisión</Alert>
              </Grid>
            }
            {isError &&
              <Grid item xs={12} sx={{ p: 0, mt: 3, display: 'flex', alignItems: 'center' }} >
                <Alert severity="error" sx={{ width: '100%' }}>No se pudieron cargar los archivos</Alert>
              </Grid>
            }
          </Grid>
          {
            openImage && selectedImage &&
            <ImageViewer
              key={`image_viewer_${revision?.pare_id}`}
              open={openImage}
              handleClose={handleCloseImage}
              selectedImage={selectedImage}
            />
          }
        </Box>
      </Fade>
    </Modal>
  )
}